import * as React from "react";

import { MeasuredContext } from "./AppResizeGroup";

/**
 * This HOC injects the Measured context (from Fabric) into the props of the wrapped component.
 * This is useful for using context props in life-cycle functions other than render like componentDidUpdate,
 * getDerivedStateFromProps etc.
 */
export function withMeasuredContext<T>(Component: React.ComponentType<T>) {
  const consumingMeasuredContext = (props: T) => {
    return (
      <MeasuredContext.Consumer>
        {(context) => <Component {...props} isMeasured={context.isMeasured} />}
      </MeasuredContext.Consumer>
    );
  };
  return consumingMeasuredContext;
}
